import React, { useEffect, useState } from 'react';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import HttpHelper from '../../service/httpService'
import moment from "moment"
import { AiOutlineDelete } from "react-icons/ai";
import DashboardWrapper from './DashboardWrapper';
import { RxCross1 } from 'react-icons/rx';
import { AiOutlineEye } from 'react-icons/ai';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";

const SecurityObjectName = 'Website.ContactInquiries';

const DashboardContactUs = (props) => {

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');
    const [loaderApi, setLoaderApi] = useState(false);

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [progress, setProgress] = useState(0);
    const [contactInquires, setContactInquires] = useState({});
    const [imageContentShow, setImageContentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);

    const getContactInquiries = async () => {
        setLoaderApi(true);
        await HttpHelper.get("ContactInquiry").then((response) => {
            if (response.status == 200) {
                setContactInquires(response.data.data);
                getAllPermission();
            } else {
                console.log(response.data.data);
            }
            setLoaderApi(false);
        })
    }

    useEffect(() => {
        getContactInquiries();
    }, [])

    const deleteInquiry = async (contactUsId) => {
        swal("Are you sure, you want to delete this record?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    await HttpHelper.delete("ContactInquiry/" + contactUsId).then((response) => {
                        if (response.status === 200) {
                            props.showToast('success', 'Record delete successfully');
                            getContactInquiries();
                        }
                    })
                }
            });
    }
    const exportToExcel = () => {

        if (!contactInquires || contactInquires.length === 0) {
            props.showToast('warning', 'No data to export');
            return;
        }

        const excelData = contactInquires.map((item, index) => ({
            '#': index + 1,
            Name: item.name || '',
            Email: item.email || '',
            Message: item.message || '',
            'Created At':
                item.createdAt && moment(item.createdAt, moment.ISO_8601, true).isValid()
                    ? moment(item.createdAt).format('MMMM D YYYY, h:mm:ss A')
                    : ''
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Contact Inquiries');

        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });

        const file = new Blob([excelBuffer], {
            type: 'application/octet-stream'
        });

        saveAs(
            file,
            `Contact_Inquiries_${moment().format('YYYYMMDD_HHmmss')}.xlsx`
        );
    };


    return (
        <DashboardWrapper>
            <div className="DashboardWrapperChild">
                <Sidebar />
                <div className="contentWrapper">
                    <HeaderDashboard progress={progress} title="Contact Inquiries" />
                    {hasAddPermissionUser == true && loaderApi == false ? <div className="container-fluid mt-80 p-0">
                        <div className="row">
                            <div className="col-md-12 mb-2 table-responsive">
                                <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign" style={{ maxHeight: 'calc(100vh - 120px)' }}>
                                    <button
                                        onClick={exportToExcel}
                                        style={{
                                            fontSize: '14px',
                                            backgroundColor: '#014022',
                                            color: '#ffffff',
                                            border: 'none',
                                            padding: '6px 14px',
                                            fontWeight: '600',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Export to Excel
                                    </button>
                                    <div className="d-flex justify-content-end mb-2">
                                      
                                    </div>

                                    <table className="table tableCustomized table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    #
                                                </th>
                                                <th>
                                                    Name
                                                </th>
                                                <th>
                                                    Email
                                                </th>
                                                <th width={"500px"}>
                                                    Message
                                                </th>
                                                <th>
                                                    Created At
                                                </th>
                                                <th>
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                contactInquires.length > 0 ?
                                                    contactInquires.map((inquiry, index) => {
                                                        return (<>
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{inquiry.name}</td>
                                                                <td>{inquiry.email}</td>
                                                                <td><div className="messageWrap">{inquiry.message}</div></td>
                                                                <td>{inquiry.createdAt !== null ? moment(inquiry.createdAt).format("MMMM D YYYY, h:mm:ss A") : 'No created Date'}</td>
                                                                <td>
                                                                    <b onClick={() => {
                                                                        var contentGet = <><div className="contentWrapPopup">
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Name :</label>
                                                                                <span>{inquiry.name}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Email :</label> 
                                                                                <span>{inquiry.email}</span>
                                                                            </div>
                                                                            <div className="contentWrapPopupGrid">
                                                                                <label>Message :</label>
                                                                                <span>{inquiry.message}</span>
                                                                            </div>
                                                                        </div></>;
                                                                        setShowImgPopup(true);
                                                                        setImageContentShow(contentGet);
                                                                    }}><AiOutlineEye /></b>
                                                                    <AiOutlineDelete onClick={() => { deleteInquiry(inquiry.contactInquiryId) }} />
                                                                </td>
                                                                {/*<td>--</td>*/}
                                                            </tr>
                                                        </>)
                                                    })
                                                    : <tr><td colSpan="6">No data found!!!</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                            <g fill="none" fill-rule="evenodd">
                                <g transform="translate(1 1)" stroke-width="2">
                                    <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                    <path d="M36 18c0-9.94-8.06-18-18-18">
                                        <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                    </path>
                                </g>
                            </g>
                        </svg>
                    </div>}





                    {/*{hasReadPermissionUser == true ? <div className="container-fluid mt-80">*/}
                    {/*    <div className="row">*/}
                    {/*        <div className="col-md-12 mb-2">*/}
                    {/*            <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign" style={{ minHeight: 'calc(100vh - 120px)' }}>*/}
                    {/*                <table className="table tableCustomized table-striped">*/}
                    {/*                    <thead>*/}
                    {/*                        <tr>*/}
                    {/*                            <th>*/}
                    {/*                                #*/}
                    {/*                            </th>*/}
                    {/*                            <th>*/}
                    {/*                                Name*/}
                    {/*                            </th>*/}
                    {/*                            <th>*/}
                    {/*                                Email*/}
                    {/*                            </th>*/}
                    {/*                            <th width={"500px"}>*/}
                    {/*                                Message*/}
                    {/*                            </th>*/}
                    {/*                            <th>*/}
                    {/*                                Created At*/}
                    {/*                            </th>*/}
                    {/*                            <th>*/}
                    {/*                                View*/}
                    {/*                            </th>*/}
                    {/*                        </tr>*/}
                    {/*                    </thead>*/}
                    {/*                    <tbody>*/}
                    {/*                        {*/}
                    {/*                            contactInquires.length > 0 ?*/}
                    {/*                                contactInquires.map((inquiry, index) => {*/}
                    {/*                                    return (<>*/}
                    {/*                                        <tr key={index}>*/}
                    {/*                                            <td>{index + 1}</td>*/}
                    {/*                                            <td>{inquiry.name}</td>*/}
                    {/*                                            <td>{inquiry.email}</td>*/}
                    {/*                                            <td><div className="messageWrap">{inquiry.message}</div></td>*/}
                    {/*                                            <td>{inquiry.createdAt !== null ? moment(inquiry.createdAt).format("MMMM D YYYY, h:mm:ss A") : 'No created Date'}</td>*/}
                    {/*                                            <td>*/}
                    {/*                                                <b onClick={() => {*/}
                    {/*                                                    var contentGet = <><div className="contentWrapPopup">*/}
                    {/*                                                        <div className="contentWrapPopupGrid">*/}
                    {/*                                                            <label>Name :</label>*/}
                    {/*                                                            <span>{inquiry.name}</span>*/}
                    {/*                                                        </div>*/}
                    {/*                                                        <div className="contentWrapPopupGrid">*/}
                    {/*                                                            <label>Email :</label>*/}
                    {/*                                                            <span>{inquiry.email}</span>*/}
                    {/*                                                        </div>*/}
                    {/*                                                        <div className="contentWrapPopupGrid">*/}
                    {/*                                                            <label>Message :</label>*/}
                    {/*                                                            <span>{inquiry.message}</span>*/}
                    {/*                                                        </div>*/}
                    {/*                                                    </div></>;*/}
                    {/*                                                    setShowImgPopup(true);*/}
                    {/*                                                    setImageContentShow(contentGet);*/}
                    {/*                                                }}><AiOutlineEye /></b>*/}
                    {/*                                            </td>*/}
                    {/*                                            */}{/*<td>--</td>*/}
                    {/*                                        </tr>*/}
                    {/*                                    </>)*/}
                    {/*                                })*/}
                    {/*                                : <tr><td colSpan="6">No data found!!!</td></tr>*/}
                    {/*                        }*/}
                    {/*                    </tbody>*/}
                    {/*                </table>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*    : <div className="NoPermission">Don't Have Permisiion</div>}*/}



                </div>
            </div>
            <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                <div className="crossPopup" onClick={() => {
                    setShowImgPopup(false);
                    setImageContentShow('');
                }}>
                    <RxCross1 />
                </div>
                <div className="contentShowPopup">
                    {imageContentShow}
                </div>
            </div>
        </DashboardWrapper>
    )
}

export default DashboardContactUs;